import React from 'react';
import { useLocation } from 'react-router';
import classNames from 'classnames';

import '../scss/Breadcrumbs.scss';
import { NavLink } from 'react-router-dom';

const Breadcrumbs = ({ formatter }) => {
  const { pathname } = useLocation();

  const crumbs = pathname.split('/');

  return (
    !crumbs.length ? null :
    <ol className="breadcrumbs">
      {crumbs.map((crumb, index) => {
        const cleanCrumb = (formatter ? formatter(crumb, index, index === crumbs.length - 1) : crumb).replace(/-/g, ' ').trim()
        return (
          <li key={index} className={classNames('breadcrumbs__crumb', {
            'breadcrumbs__crumb--active': index === crumbs.length - 1})
          }>
            <NavLink className="breadcrumbs__crumb__link" to={`/${crumbs.slice(0, index + 1).filter(Boolean).join('/')}`}>{index === 0 ? 'Home' : cleanCrumb}</NavLink>
          </li>
        );
      })}
    </ol>
  );
};

export default Breadcrumbs;